import {Component, OnInit} from '@angular/core';
import {FormGroup}         from '@angular/forms';
import {NewsStore}         from '../../stores/dashboard/news.store';
import {filter, map}       from 'rxjs/operators';
import {LoginStore}        from '../../stores/login/login.store';
import {LanguageStore}     from '../../stores/translation/language.store';

interface INewsData {
  title: string;
  content: any;
  expanded: boolean;
}

/**
 * Component for the news
 */
@Component({
  selector: 'ap-news-overview',
  templateUrl: 'ap-news.component.html',
  styleUrls: ['ap-news.component.scss']
})

export class ApNewsOverviewComponent implements OnInit {
  public form: FormGroup;
  public newsLoading$ = this.newsStore.Listen(s => s.loading);
  public url = 'https://www.agricon.de/aktuelles/iframe';
  public items$ = this.newsStore.Listen(s => s.data).pipe(
    filter(d => !!d),
    map(d => d.Convert<INewsData>(n => {
      return {
        title: n.Caption,
        content: n.Newshtml,
        expanded: false
      };
    }))
  );

  constructor(private newsStore: NewsStore,
              private loginStore: LoginStore,
              private languageStore: LanguageStore) {
  }

  ngOnInit(): void {
    this.newsStore.loadNews(this.loginStore.SelectedFarm.Country?.Id);
    this.languageStore.SelectedLanguage$.subscribe(s => {
      switch (s.Key) {
        case 'de':
          this.url = 'https://www.agricon.de/aktuelles/iframe';
          break;
        case 'en':
          this.url = 'https://www.agricon.de/en/news/iframe';
          break;
        case 'pl':
          this.url = 'https://www.agricon.de/en/news/iframe';
          break;
        case 'lt':
          this.url = 'https://www.agricon.de/en/news/iframe';
          break;
        case 'lv':
          this.url = 'https://www.agricon.de/en/news/iframe';
          break;
        case 'et':
          this.url = 'https://www.agricon.de/en/news/iframe';
          break;
        case 'sr':
          this.url = 'https://www.agricon.de/en/news/iframe';
          break;
        case 'uk':
          this.url = 'https://www.agricon.de/en/news/iframe';
          break;
        case 'hu':
          this.url = 'https://www.agricon.de/en/news/iframe';
          break;
        case 'ru':
           this.url = 'https://www.agricon.de/en/news/iframe';
          break;
        case 'cs':
          this.url = 'https://www.agricon.de/en/news/iframe';
          break;
        case 'hr':
          this.url = 'https://www.agricon.de/en/news/iframe';
          break;
        case 'sk':
          this.url = 'https://www.agricon.de/en/news/iframe';
          break;
        case 'ro':
          this.url = 'https://www.agricon.de/en/news/iframe';
          break;
      }
    });
  }
}
